<script setup lang="ts">
import { reactive } from "vue";
import Container, {
  ContainerType,
  EffectTriggerTiming
} from "../Container.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Container },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    containerType?: ContainerType;
    supportCopyText?: boolean;
    effectTriggerTiming?: EffectTriggerTiming;
    color?: string;
    timeGap?: number;
    direction?:
      | "fromBottomLeft"
      | "fromBottomRight"
      | "fromTopLeft"
      | "fromTopRight"
      | "fromCenter";
  }>(),
  {
    containerType: "shrink",
    supportCopyText: true,
    effectTriggerTiming: "mouseMove",
    color: "#3cefff",
    timeGap: 100,
    direction: "fromBottomLeft"
  }
);

// const emits = defineEmits<{
//   (event: "click"): void;
// }>();

const style = reactive<Record<string, string>>({});

let ratio = 1;
let scale = ratio * 2;
const resize = (controller) => {
  ratio = Math.ceil(
    Math.max(controller.rect.width, controller.rect.height) /
      Math.min(controller.rect.width, controller.rect.height)
  );
  scale = ratio * 2;
  style.width = style.height =
    Math.ceil(Math.min(controller.rect.width, controller.rect.height)) + "px";
};

const start = () => {
  switch (props.direction) {
    case "fromBottomLeft":
      style.top = "100%";
      style.right = "100%";
      style.transform = "translate(50%, -50%) scale3d(0, 0, 0)";
      break;
    case "fromBottomRight":
      style.top = "100%";
      style.left = "100%";
      style.transform = `translate(-50%, -50%) scale3d(0, 0, 0)`;
      break;
    case "fromTopLeft":
      style.bottom = "100%";
      style.right = "100%";
      style.transform = `translate(50%, 50%) scale3d(0, 0, 0)`;
      break;
    case "fromTopRight":
      style.bottom = "100%";
      style.left = "100%";
      style.transform = `translate(-50%, 50%) scale3d(0, 0, 0)`;
      break;
    case "fromCenter":
      style.top = "50%";
      style.left = "50%";
      style.transform = `translate(-50%, -50%) scale3d(0, 0, 0)`;
      break;
  }
};
const end = () => {
  switch (props.direction) {
    case "fromBottomLeft":
      style.top = "100%";
      style.right = "100%";
      style.transform = `translate(50%, -50%) scale3d(${scale}, ${scale}, ${scale})`;
      break;
    case "fromBottomRight":
      style.top = "100%";
      style.left = "100%";
      style.transform = `translate(-50%, -50%) scale3d(${scale}, ${scale}, ${scale})`;
      break;
    case "fromTopLeft":
      style.bottom = "100%";
      style.right = "100%";
      style.transform = `translate(50%, 50%) scale3d(${scale}, ${scale}, ${scale})`;
      break;
    case "fromTopRight":
      style.bottom = "100%";
      style.left = "100%";
      style.transform = `translate(-50%, 50%) scale3d(${scale}, ${scale}, ${scale})`;
      break;
    case "fromCenter":
      style.top = "50%";
      style.left = "50%";
      style.transform = `translate(-50%, -50%) scale3d(${scale}, ${scale}, ${scale})`;
      break;
  }
};

defineExpose({});
</script>

<template>
  <Container
    :type="props.containerType"
    :supportCopyText="props.supportCopyText"
    :effectTriggerTiming="props.effectTriggerTiming"
    @start="start"
    @end="end"
    @ready="resize"
    @update="resize"
    style="overflow: hidden"
  >
    <div
      class="slide-corner-before"
      :style="{
        backgroundColor: props.color,
        borderRadius: '50%',
        transition: `transform ${props.timeGap * ratio}ms ease-in-out`,
        transformOrigin: 'center',
        ...style
      }"
    ></div>
    <div class="slide-corner">
      <slot></slot>
    </div>
  </Container>
</template>

<style scoped>
.slide-corner-before {
  position: absolute;
  z-index: 0;
}
.slide-corner {
  position: relative;
  z-index: 1;
  cursor: pointer;
}
</style>
